(function() {
  'use strict';

  function EmailTypeSlotController($uibModal, $translate, EmailTypes, Security, Notify) {
    var ctrl = this;

    ctrl.$onInit = function() {
      ctrl.setup();
    };

    ctrl.setup = function() {
      ctrl.actionButtons = [
        {
          label: $translate.instant('View'),
          icon: 'icon-view',
          route: (function() {
            return ['/emails', ctrl.emailType.doc.id];
          })(),
          showCondition: Security.hasPermission.bind(this, 'emailTemplates.view'),
          klass: 'text-info'
        },
        {
          label: $translate.instant('View sent emails'),
          icon: 'icon-view',
          route: (function() {
            return ['/emails', ctrl.emailType.doc.id, 'log'];
          })(),
          showCondition: Security.hasPermission.bind(this, 'emailTemplates.view'),
          klass: 'text-info'
        }
      ];
      ctrl.secondaryActionButtons = [
        {
          label: $translate.instant('Send test email'),
          icon: 'icon-edit',
          onClick: function() {
            EmailTypes.sendTestEmail(ctrl.emailType.doc.id)
              .then(function() {
                Notify.success('A test email has been sent to your email address');
              })
              .catch(function(err) {
                var msg = 'Unknown error';
                if (err && err.message) {
                  msg = err.message;
                }
                Notify.error(msg);
              });
          },
          showCondition: Security.hasPermission.bind(this, 'emailTemplates.view'),
          klass: 'text-info'
        },
        {
          label: $translate.instant('Preview test email'),
          icon: 'icon-edit',
          onClick: function() {
            ctrl.preview();
          },
          showCondition: Security.hasPermission.bind(this, 'emailTemplates.view'),
          klass: 'text-info'
        }
      ];

      ctrl.preview = function() {
        $uibModal.open({
          animation: true,
          template: '<email-type-preview email-type-id="ctrl.emailTypeId" ' +
                    'on-close="$close()"></email-type-preview>',
          controller: ['emailTypeId',
            function(emailTypeId) {
              this.emailTypeId = emailTypeId;
            }
          ],
          controllerAs: 'ctrl',
          resolve: {
            emailTypeId: function() {
              return ctrl.emailType.doc.id;
            }
          },
          size: 'lg'
        }).result.catch(function(err) {
          console.log('Dismissed', err);
        });
      };
    };
  }

  EmailTypeSlotController.$inject = [
    '$uibModal',
    '$translate',
    'EmailTypesService',
    'SecurityService',
    'NotifyService'


  ];

  angular.module('component.emailTemplates')
    .component('emailTypeSlot', {
      templateUrl: 'app/components/email-templates/email-type-slot.html',
      controller: EmailTypeSlotController,
      bindings: {
        emailType: '<',
        options: '<'
      }
    });
})();
